export const updateAlert = (payload) => {
    
    return {
        type:'UPDATE_ALERT',
        payload
    }
}